import axios from "axios";

// Utils
import { convertStringToDate } from "../../../helpers/utils";

// Config
import { config } from "../config";

// Constants
import {
  MAPPED_DLQ,
  MAPPED_DLQ_DOWNLOAD_LINK,
} from "../../../constants/DeadLetterQueuesConstants";

/**
 * get getdeadLetterQueue list based on query parameter
 *
 * @param {object} query
 */
function getMappedDeadLetterQueueList(query, requestHeaders) {
  let url = `${config.apiUrl}/dlq/mapped-0709?size=${
    query?.pageSize || 50
  }&page=${query?.page || 0}`;

  if (query?.orderBy && query?.orderDirection !== "") {
    url += `&sort=${query?.orderBy?.field}&order=${query?.orderDirection}`;
  }

  //handle filter
  if (query?.filters && query?.filters?.length > 0) {
    let filters = "";
    query?.filters?.map((filter) => {
      if (filters !== "") {
        filters += "&";
      }
      return (filters += `${filter.column.field}${filter.operator}${filter.value}`);
    });
    url += `&${filters}`;
  }

  return axios
    .get(url, { headers: requestHeaders })
    .then((resp) => {
      if (resp.data) {
        resp.data.content.map((row) => {
          row.empfangenAm = row.empfangenAm
            ? convertStringToDate(row.empfangenAm)
            : "";
          return row;
        });
        return resp.data;
      }
    })
    .catch((error) => {
      return error;
    });
}

function exportMappedDeadLetterQueueXML(antragsnummer, requestHeaders) {
  const url = `${config.apiUrl}/dlq/mapped-0709/${antragsnummer}/xml`;
  return axios
    .get(url, {
      headers: requestHeaders,
    })
    .then((resp) => {
      return resp;
    })
    .catch((error) => {
      return error;
    });
}

/**
 * get get unmatched deadLetterQueue list based on query parameter
 *
 * @param {object} query
 */
function getUnmappedDeadLetterQueueList(query, requestHeaders) {
  let url = `${config.apiUrl}/sabrina/dlq/orphan-0709?size=${
    query?.pageSize || 50
  }&page=${query?.page || 0}`;

  if (query?.orderBy && query?.orderDirection !== "") {
    url += `&sort=${query?.orderBy?.field}&order=${query?.orderDirection}`;
  }

  //handle filter
  if (query?.filters && query?.filters?.length > 0) {
    let filters = "";
    query?.filters?.map((filter) => {
      if (filters !== "") {
        filters += "&";
      }
      return (filters += `${filter.column.field}${filter.operator}${filter.value}`);
    });
    url += `&${filters}`;
  }

  return axios
    .get(url, { headers: requestHeaders })
    .then((resp) => {
      if (resp.data) {
        resp.data.content.map((row) => {
          row.empfangenAm = row.empfangenAm
            ? convertStringToDate(row.empfangenAm)
            : "";
          return row;
        });

        return resp.data;
      }
    })
    .catch((error) => {
      return error;
    });
}

function exportUnmappedDeadLetterQueueXML(nachrichtenId, requestHeaders) {
  const url = `${config.apiUrl}/sabrina/dlq/orphan-0709/${nachrichtenId}/xml`;
  return axios
    .get(url, {
      headers: requestHeaders,
    })
    .then((resp) => {
      return resp;
    })
    .catch((error) => {
      return error;
    });
}

const requestForDeadLetterQueuePDFs = async (
  dlqType,
  requestData,
  requestHeaders
) => {
  let appendedUrl =
    dlqType === MAPPED_DLQ
      ? "/dlq/mapped-0709/download-req"
      : "/sabrina/dlq/orphan-0709/download-req";

  let url = `${config.apiUrl}${appendedUrl}`;

  try {
    const resp = await axios.post(url, requestData, {
      headers: requestHeaders,
    });
    return resp;
  } catch (error) {
    return error;
  }
};

const getDeadLetterQueueZipDownload = async (isDLQType, requestId) => {
  const isMapped = isDLQType === MAPPED_DLQ_DOWNLOAD_LINK ? "true" : "false";

  const url = `${config.apiUrl}/sabrina/dlq/${requestId}/zip?isMapped=${isMapped}`;

  try {
    const resp = await axios.get(url, {
      responseType: "blob",
    });
    return resp;
  } catch (error) {
    return error;
  }
};

// exports the object of methods
export const deadLetterQueueService = {
  getMappedDeadLetterQueueList,
  exportMappedDeadLetterQueueXML,
  getUnmappedDeadLetterQueueList,
  exportUnmappedDeadLetterQueueXML,
  requestForDeadLetterQueuePDFs,
  getDeadLetterQueueZipDownload,
};
